import { render, staticRenderFns } from "./FinanceremittanceList.vue?vue&type=template&id=64918e64&scoped=true"
import script from "./FinanceremittanceList.vue?vue&type=script&lang=js"
export * from "./FinanceremittanceList.vue?vue&type=script&lang=js"
import style0 from "./FinanceremittanceList.vue?vue&type=style&index=0&id=64918e64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64918e64",
  null
  
)

export default component.exports